import React, {Component} from 'react';
import './Invite.css';
import {Alert, Button, Col, Divider, Modal, Result, Row, Spin} from 'antd';
import {getInvite, triggerInviteAction} from "../../services/InvitesService";
import {EnvironmentOutlined, HomeOutlined, InfoCircleOutlined, UnlockOutlined} from "@ant-design/icons";
import moment from "moment";
import {showError, showInformation} from "../../services/APIService";

class Invite extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        };
        this.executeAction = this.executeAction.bind(this);
        this.checkResolveLocation = this.checkResolveLocation.bind(this);
    }

    loadInvite() {
        this.setState({
            isLoading: true
        });
        getInvite(this.props.id)
            .then(response => {
                this.setState({
                    invite: response,
                    isLoading: false
                });
            }).catch(error => {
            this.setState({
                isLoading: false
            });
        });
    }

    componentDidMount() {
        this.loadInvite();
    }

    getConfigurationProperty(action, property, defaultValue) {
        if (action.hasOwnProperty('configuration') && action.configuration.hasOwnProperty(property))
            return action.configuration[property];
        return defaultValue;
    }

    checkResolveLocation(action) {
        this.setState({
            isLoading: true,
            action: action
        });
        navigator.geolocation.getCurrentPosition(
            position => {
                this.executeAction(action, position.coords);
            },
            error => {
                this.setState({
                    isLoading: false
                });
                if (error && error.message) {
                    showError(<div>
                        <div>Acción cancelada</div>
                        <p>Por seguridad se require habilitar el servicio de geolocalización</p><p>{error.message}</p>
                    </div>);
                } else {
                    showError(<div>
                        <div>Acción cancelada</div>
                        <p>Por seguridad se require habilitar el servicio de geolocalización</p></div>);
                }
            }
        );
    }

    showConfirmation(t, action, execute) {
        Modal.confirm({
            width: 500,
            title: 'Confirmación',
            content: <div className="action-container alert-container">
                <h2 className="action-alert ant-alert-info">{action.name}</h2>
                <Alert message={'Esta acción será ejecutada. ¿Está seguro que desea continuar?'} type="warning"/>
            </div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            centered: true,
            okButtonProps: {size: 'large', icon: 'check-circle'},
            cancelButtonProps: {size: 'large', icon: 'close-circle'},
            onOk() {
                execute(action);
            }
        })
    }

    executeAction(action, coords) {
        triggerInviteAction(this.state.invite.id, action.id, coords)
            .then(response => {
                setTimeout(() => {
                    this.setState({
                        isLoading: false
                    });
                }, 5000);
            })
            .catch(error => {
                if (typeof error.json === 'function') {
                    error.json().then(json => {
                        if (json.status && json.status === 428) {
                            const clientDisabled = json['params']['client-disabled'] === true;
                            if (clientDisabled || json['params']['client-offline'] === true) {
                                showError('El equipo receptor no puede recibir su solicitud en estos momentos. Puede ser un problema temporal debido a la conectividad a internet o falla eléctrica. Intente nuevamente en unos instantes');
                            } else {
                                showError(json.message);
                            }
                        } else if (json.status && json.status === 412) {
                            showError('Esta solicitud ha sido bloqueada. Se ha prohibido el acceso');
                        } else if (json.status && json.status === 424) {
                            if (json.message === 'NO_LOCATION') {
                                showError('No se ha podido determinar su ubicación. Esta solicitud ha sido bloqueada.');
                            } else {
                                showError(<div>
                                    <p>La ubicación reportada por su dispositivo se encuentra <b>muy lejos</b> de la dirección indicada.</p>
                                    <p>Revise los permisos de acceso a su <b>ubicación precisa</b> y/o <b>refresque esta página</b>.</p>
                                    <sub>Verifique la ubicación de su dispositivo usando aplicaciones como <b>Maps</b>, su dispositivo puede estar reportando su última ubicación conocida y no la actual</sub>
                                </div>);
                            }
                        } else {
                            showError(json.message);
                        }
                    });
                } else {
                    showError(error.message);
                }
                this.setState({
                    isLoading: false
                });
            });
    }

    render() {
        const notFound = <Result status="404" title="404" subTitle="Este recurso ya no se encuentra disponible"/>;
        if (this.state.notFound) {
            return notFound;
        }

        if (this.state.isLoading) {
            return <div className="main-spin-container"><Spin size="large"/></div>;
        }

        const actions = [];
        if (this.state.invite && this.state.invite.actions) {
            this.state.invite.actions.forEach((action, index) => {
                actions.push(
                    <div className="action" key={"action_row_" + action.id}>
                        <Row>
                            <Col xs={24} sm={12}>
                                <Button key={action.id} disabled={this.state.invite.enabled ? '' : 'disabled'}
                                        type={this.getConfigurationProperty(action, 'type', 'danger')}
                                        icon={this.getConfigurationProperty(action, 'icon', 'home')}
                                        className="action"
                                        onClick={(e) => this.showConfirmation(this.props.t, action, this.checkResolveLocation)}
                                        loading={this.state && this.state.isLoading && this.state.action === action.id}>
                                    {action.name}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                )
            });
        }

        return (this.state.invite ?
            <div className="invite-container">
                <Result
                    title={this.state.invite.client.name}
                    subTitle={this.state.invite.client.address}
                    extra={
                        <div>
                            <Button type="link" onClick={
                                (e) => showInformation('Acceso a su ubicación', <div>
                                    <p>Se necesita conocer su ubicación precisa actual antes de completar cualquier solicitud.</p>
                                    <p>En caso de no conceder permisos de <b>ubicación precisa</b> se rechazará el acceso, de igual modo, no se garantiza el acceso si sólo permite acceso a ubicación aproximada</p>
                                </div>)
                            }><EnvironmentOutlined/> Se reportará su ubicación actual</Button>
                            <div className="actions">{actions}</div>
                        </div>
                    }>
                    {
                        <div className="desc">
                            <div className="center"><b>{moment(this.state.invite.startDate).format('YYYY-MM-DD h:mm a')}</b></div>
                            <Divider className="dates"><UnlockOutlined/></Divider>
                            <div className="center"><b>{moment(this.state.invite.endDate).format('YYYY-MM-DD h:mm a')}</b></div>
                            <Divider/>
                            <div><HomeOutlined/> <b>Anfitrión:</b> {this.state.invite.user.name}</div>
                            <div><InfoCircleOutlined/> <b>Motivo:</b> {this.state.invite.name}</div>
                        </div>
                    }
                </Result>
            </div>
            :
            notFound);
    }
}

export default Invite;


// WEBPACK FOOTER //
// ./src/app/views/invite/Invite.js